import Config from '../Config';
import Services from './services';

const UploadModel = {
    upload: (formdata) => {
        return Services.postApi(Config.getBasePath() + '/images', formdata, false, 'multipart/form-data');
    },
};
export default UploadModel;
